/* ============================================================
   CURRENCY SWITCHER  —  display-only conversion
   The store's only presentment currency is USD, so checkout is
   always in dollars. This converts the numbers people read, and
   the panel says so. Every price found on the page is wrapped
   once in a span carrying its dollar value; from then on
   switching is just a rewrite of those spans, so it can never
   drift or compound.

   Rates: cached in the browser for a day, fetched from a static
   CDN with a second source behind it and the pegged rates behind
   that — the Gulf currencies are all pegged to the dollar, so the
   fallback is right to the third decimal anyway. Kuwait tracks a
   basket rather than the dollar, which is the one that moves.
   ============================================================ */
(function(){
  'use strict';

  var DP   = {USD:2, AED:2, SAR:2, QAR:2, KWD:3, BHD:3, OMR:3};
  /* pegged rates — the offline floor, and the first paint before the fetch lands */
  var PEG  = {USD:1, AED:3.6725, SAR:3.75, QAR:3.64, KWD:0.3089, BHD:0.376, OMR:0.3845};
  var KEY  = 'urbanleb_fx';
  var RKEY = 'urbanleb_fx_rates';
  var DAY  = 864e5;

  var wrap  = document.getElementById('ulfxWrap');
  var btn   = document.getElementById('ulfxBtn');
  var menu  = document.getElementById('ulfxMenu');
  var label = document.getElementById('ulfxCur');
  if(!wrap || !btn || !menu || !label) return;

  var opts  = [].slice.call(menu.querySelectorAll('.ulfx-opt'));
  var codes = opts.map(function(o){ return o.getAttribute('data-cur'); });
  var rates = {};
  var cur   = 'USD';
  var mute  = false, mtimer = null;

  try{ var saved = localStorage.getItem(KEY); if(saved && codes.indexOf(saved) > -1) cur = saved; }catch(e){}

  /* ---------- rates ---------- */
  function useRates(r){
    if(!r) return;
    var got = false;
    codes.forEach(function(c){
      var v = r[c] || r[c.toLowerCase()];
      if(typeof v === 'number' && isFinite(v) && v > 0){ rates[c] = v; got = true; }
    });
    if(got){ rates.USD = 1; paint(); }
  }
  function cacheRates(){
    try{ localStorage.setItem(RKEY, JSON.stringify({t:Date.now(), r:rates})); }catch(e){}
  }
  function loadRates(){
    var fresh = false;
    try{
      var c = JSON.parse(localStorage.getItem(RKEY) || 'null');
      if(c && c.r && (Date.now() - c.t) < DAY){ useRates(c.r); fresh = true; }
    }catch(e){}
    if(fresh) return;                       /* one fetch a day, no more */
    fetchFrom(
      'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.json',
      function(d){ return d && d.usd; },
      function(){
        fetchFrom('https://open.er-api.com/v6/latest/USD',
          function(d){ return d && d.rates; },
          function(){}   /* both sources down — the pegs already carry it */
        );
      }
    );
  }
  function fetchFrom(url, pick, onFail){
    var done = false, kill = setTimeout(function(){ if(!done){ done = true; onFail(); } }, 6000);
    fetch(url, {mode:'cors', cache:'default'})
      .then(function(r){ return r.ok ? r.json() : Promise.reject(0); })
      .then(function(d){
        if(done) return; done = true; clearTimeout(kill);
        var r = pick(d);
        if(r){ useRates(r); cacheRates(); } else onFail();
      })
      .catch(function(){ if(!done){ done = true; clearTimeout(kill); onFail(); } });
  }

  /* ---------- formatting ---------- */
  function group(s){
    var p = String(s).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return p.join('.');
  }
  function fmt(usd, code){
    var rate = rates[code] || PEG[code] || 1;
    var v = group((usd * rate).toFixed(DP[code] == null ? 2 : DP[code]));
    return code === 'USD' ? '$' + v : code + ' ' + v;
  }

  /* ---------- find prices once, rewrite them for ever after ---------- */
  var RX   = /\$\s?\d[\d,]*(?:\.\d{1,2})?/g;
  var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT|OPTION|CODE|PRE)$/;

  function harvest(root){
    if(!root || !root.nodeType) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(n){
        if(!n.nodeValue || n.nodeValue.indexOf('$') < 0) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if(!p || p.nodeType !== 1) return NodeFilter.FILTER_REJECT;
        if(SKIP.test(p.nodeName)) return NodeFilter.FILTER_REJECT;
        if(p.classList && p.classList.contains('ulfx-n')) return NodeFilter.FILTER_REJECT;
        if(p.closest && p.closest('.ulfx-wrap,[data-nofx]')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var hits = [], n;
    while((n = walker.nextNode())) hits.push(n);

    hits.forEach(function(t){
      var s = t.nodeValue, frag = null, i = 0, m;
      RX.lastIndex = 0;
      while((m = RX.exec(s))){
        if(!frag) frag = document.createDocumentFragment();
        if(m.index > i) frag.appendChild(document.createTextNode(s.slice(i, m.index)));
        var span = document.createElement('span');
        span.className = 'ulfx-n';
        span.setAttribute('data-usd', m[0].replace(/[^0-9.]/g, ''));
        span.textContent = m[0];
        frag.appendChild(span);
        i = m.index + m[0].length;
      }
      if(!frag) return;
      if(i < s.length) frag.appendChild(document.createTextNode(s.slice(i)));
      if(t.parentNode) t.parentNode.replaceChild(frag, t);
    });
  }

  function paint(){
    var els = document.getElementsByClassName('ulfx-n');
    for(var i = 0; i < els.length; i++){
      var e = els[i], usd = parseFloat(e.getAttribute('data-usd'));
      if(isFinite(usd)) e.textContent = fmt(usd, cur);
    }
    drawerNote();
  }

  /* off the dollar, the bag says where the charge actually lands */
  function drawerNote(){
    var note = document.querySelector('.cart-drawer__shipping-note');
    if(!note) return;
    var tag = note.querySelector('.ulfx-usd');
    if(cur === 'USD'){ if(tag) tag.remove(); return; }
    if(!tag){ tag = document.createElement('i'); tag.className = 'ulfx-usd'; note.appendChild(tag); }
    tag.textContent = 'Charged in USD at checkout';
  }

  function sweep(root){
    mute = true;
    harvest(root || document.body);
    paint();
    mute = false;
  }

  /* prices arrive late too — bag drawer, quick view, search results */
  var mo = new MutationObserver(function(){
    if(mute) return;
    clearTimeout(mtimer);
    mtimer = setTimeout(function(){ sweep(document.body); }, 70);
  });

  /* ---------- the control ---------- */
  function mark(){
    label.textContent = cur;
    opts.forEach(function(o){
      o.setAttribute('aria-selected', o.getAttribute('data-cur') === cur ? 'true' : 'false');
    });
  }
  function open(){ wrap.classList.add('open'); btn.setAttribute('aria-expanded','true'); }
  function close(){ wrap.classList.remove('open'); btn.setAttribute('aria-expanded','false'); }

  btn.addEventListener('click', function(e){
    e.stopPropagation();
    wrap.classList.contains('open') ? close() : open();
  });
  menu.addEventListener('click', function(e){
    var o = e.target.closest('.ulfx-opt'); if(!o) return;
    cur = o.getAttribute('data-cur');
    try{ localStorage.setItem(KEY, cur); }catch(err){}
    mark(); mute = true; paint(); mute = false; close(); btn.focus();
  });
  document.addEventListener('click', function(e){
    if(wrap.classList.contains('open') && !wrap.contains(e.target)) close();
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && wrap.classList.contains('open')){ close(); btn.focus(); }
  });

  /* ---------- go ---------- */
  mark();
  sweep(document.body);
  mo.observe(document.body, {childList:true, subtree:true, characterData:true});
  loadRates();
})();

/* ============================================================
   HEADER STATE
   Two jobs the theme's inline scroll handler does not do:
   .hero-lit  — on the homepage only, marks the point where the
                opening scene is behind you and the bar should
                become a solid surface again.
   the sync   — the theme sets .scrolled on scroll events alone,
                so reloading half way down a page used to leave a
                see-through bar sitting over the content until
                you happened to scroll. Both states are now also
                settled once on load.
   ============================================================ */
(function(){
  var head = document.getElementById('siteHeader');
  if(!head) return;
  var home = document.body.classList.contains('template-index');

  function sync(){
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    head.classList.toggle('scrolled', y > 60);
    if(home) head.classList.toggle('hero-lit', y > window.innerHeight * 0.66);
  }

  sync();
  window.addEventListener('scroll', sync, {passive:true});
  window.addEventListener('resize', sync, {passive:true});
  window.addEventListener('pageshow', sync);
})();

/* ============================================================
   WARM THE NEXT PAGE
   Tapping a category costs about three quarters of a second
   before the server even answers, and that wait is what reads
   as lag — the menu itself is already open by then. So the
   moment someone shows intent (hovers on a desktop, or puts a
   finger down on a phone) the destination starts downloading in
   the background. By the time the tap completes the HTML is
   usually already in the browser's cache and the page swaps in.

   Deliberately modest: same-origin pages only, never the cart
   or account or checkout (those must always be fresh), each URL
   warmed once, and a hard ceiling of eight per page view so a
   long scroll past a grid of links cannot turn into a download
   spree. Skipped outright on save-data or a 2G connection.
   ============================================================ */
(function(){
  var probe = document.createElement('link');
  if(!probe.relList || !probe.relList.supports || !probe.relList.supports('prefetch')) return;

  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

  var seen = Object.create(null), budget = 8;
  var SKIP = /^\/(cart|checkout|account|challenge|password)(\/|$)/;

  function warm(href){
    if(budget <= 0 || !href) return;
    var u;
    try{ u = new URL(href, location.href); }catch(e){ return; }
    if(u.origin !== location.origin) return;
    if(SKIP.test(u.pathname)) return;
    var key = u.pathname + u.search;
    if(key === location.pathname + location.search) return;
    if(seen[key]) return;
    seen[key] = 1; budget--;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.as = 'document';
    l.href = u.href;
    document.head.appendChild(l);
  }

  function intent(e){
    var t = e.target;
    if(!t || !t.closest) return;
    var a = t.closest('a[href]');
    if(!a) return;
    if(a.target && a.target !== '_self') return;
    if(a.hasAttribute('download')) return;
    var href = a.getAttribute('href');
    if(!href || href.charAt(0) === '#') return;
    warm(href);
  }

  document.addEventListener('pointerover', intent, {passive:true});
  document.addEventListener('touchstart',  intent, {passive:true});
  document.addEventListener('focusin',     intent, {passive:true});
})();

/* ============================================================
   SEAM END BUTTON — send it down the page, not off it
   The scene fades #sw-btn in by writing to that element every
   frame, so the node has to survive; only its behaviour changes.
   Clicking scrolls to the end of the hero's pinned run, which is
   exactly where the next section begins.
   ============================================================ */
(function(){
  var btn   = document.getElementById('sw-btn');
  var stage = document.getElementById('ulthStage');
  if(!btn || !stage || btn.tagName !== 'A') return;

  btn.setAttribute('aria-label', 'Scroll to the next section');

  btn.addEventListener('click', function(e){
    if(e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;  /* let them open it properly */
    e.preventDefault();
    var y = stage.getBoundingClientRect().top + (window.scrollY || 0) + stage.offsetHeight;
    try{ window.scrollTo({top:y, behavior:'smooth'}); }catch(err){ window.scrollTo(0, y); }
  });
})();

/* ============================================================
   IDLE THE SECTIONS THAT ARE OFF SCREEN
   The page was running about a hundred CSS animations at once
   and only a handful of them were anywhere a visitor could see.
   Each section is watched, and everything inside one that has
   scrolled away is paused until it comes back. Marquees pick up
   from where they stopped, so nothing jumps.
   ============================================================ */
(function(){
  if(!('IntersectionObserver' in window)) return;
  var els = document.querySelectorAll('.fr, .bl, .cw, .product-grid, .ulsw, .footer-grid');
  if(!els.length) return;

  var io = new IntersectionObserver(function(rows){
    for(var i = 0; i < rows.length; i++){
      rows[i].target.classList.toggle('ul-idle', !rows[i].isIntersecting);
    }
  }, {rootMargin: '300px 0px'});   /* wake a little before it is reached */

  for(var i = 0; i < els.length; i++){
    els[i].classList.add('ul-idle');
    io.observe(els[i]);
  }
})();

/* ============================================================
   ONE LAYOUT READ PER FRAME, NOT PER SCROLL EVENT
   The theme's scroll handler calls checkStickyATC(), which
   measures an element — a forced layout — on every single scroll
   event. Scroll events fire far faster than the screen redraws,
   so the same measurement was being taken several times per
   frame and thrown away. Now it happens once, on the frame.
   ============================================================ */
(function(){
  if(typeof window.checkStickyATC !== 'function') return;
  var real = window.checkStickyATC, queued = false;
  window.checkStickyATC = function(){
    if(queued) return;
    queued = true;
    requestAnimationFrame(function(){ queued = false; real(); });
  };
})();